
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserManagementTab } from "./admin/UserManagementTab";

interface AdminSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const AdminSettingsDialog = ({ open, onOpenChange }: AdminSettingsDialogProps) => {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-4xl max-h-[80vh] overflow-hidden">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold text-gray-900">
            Admin Settings
          </DialogTitle>
        </DialogHeader>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-3 mb-6">
            <TabsTrigger value="users" className="text-sm font-medium">
              User Management
            </TabsTrigger>
            <TabsTrigger value="system" className="text-sm font-medium">
              System Settings
            </TabsTrigger>
            <TabsTrigger value="security" className="text-sm font-medium">
              Security
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="users" className="mt-0">
            <UserManagementTab />
          </TabsContent>
          
          <TabsContent value="system" className="mt-0">
            <div className="p-6 text-center text-gray-500">
              <p>System settings will be available soon.</p>
            </div>
          </TabsContent>
          
          <TabsContent value="security" className="mt-0">
            <div className="p-6 text-center text-gray-500">
              <p>Security settings will be available soon.</p>
            </div>
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default AdminSettingsDialog;
